import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import { accessApi } from '@/services/admin';
import { Select } from '@/components/ui';

export function useDirectory() {
  return useQuery({ queryKey: ['directory'], queryFn: () => accessApi.directory(), staleTime: 5 * 60_000 });
}

export function UserSelect({ value, onChange, placeholder = 'Select a person', id, allowEmpty = true }: { value: string; onChange: (v: string) => void; placeholder?: string; id?: string; allowEmpty?: boolean }) {
  const dir = useDirectory();
  return (
    <Select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
      {allowEmpty && <option value="">{dir.isLoading ? 'Loading…' : placeholder}</option>}
      {dir.data?.map((u) => <option key={u._id} value={u._id}>{u.name}</option>)}
    </Select>
  );
}

export function MultiUserSelect({ value, onChange, id }: { value: string[]; onChange: (v: string[]) => void; id?: string }) {
  const dir = useDirectory();
  const byId = new Map(dir.data?.map((u) => [u._id, u]) ?? []);
  return (
    <div className="space-y-2">
      <Select id={id} value="" onChange={(e) => e.target.value && !value.includes(e.target.value) && onChange([...value, e.target.value])}>
        <option value="">{dir.isLoading ? 'Loading…' : 'Add a person…'}</option>
        {dir.data?.filter((u) => !value.includes(u._id)).map((u) => <option key={u._id} value={u._id}>{u.name}</option>)}
      </Select>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {value.map((id) => (
            <span key={id} className="inline-flex items-center gap-1 rounded-md bg-brand-soft px-2 py-1 text-xs font-medium text-brand-ink">
              {byId.get(id)?.name ?? '…'}
              <button type="button" onClick={() => onChange(value.filter((v) => v !== id))} aria-label={`Remove ${byId.get(id)?.name ?? 'person'}`}><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
